import type { Auth0UserLike, RegionalUserLike } from '../../types/auth0-user.type'

import { getFallbackFirstName } from './getFallbackFirstName'
import { getFullName } from './getFullName'
import { getProfileValue } from './getProfileValue'
import { normalizeValue } from './normalizeValue'

export const getFirstName = (
  auth0User: Auth0UserLike,
  email: string,
  regionalData?: RegionalUserLike | null
): string => {
  const { firstName } = getFullName(auth0User)

  return (
    normalizeValue(regionalData?.firstname) ||
    getProfileValue(auth0User.profile?.given_name, auth0User.given_name) ||
    firstName ||
    getFallbackFirstName(auth0User, email)
  )
}
